;var OrderContent = function( content ) {

  $.each( content, function( i ) {
    content[i].id = i;

    var year = content[i].nascimento.data;

    if ( year != undefined || year != null ) {
      year = year.split( '/' );
      year = year[year.length - 1];
      
      content[i].ano = parseInt( year );
    }

    if ( content[i].generos != undefined || content[i].generos != null ) {
      content[i].generos.push( content[i].tipo )
    }
  });

  content = SortJSON( content, 'ano', true );

  return content;

};
